import React, { Component } from 'react';
import { Card, Spin, Tooltip } from 'antd';
import './seat.less';
import { queryIncuStationList } from '@api/incubator/station';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      unitClass: {},
      columns: [],
      rows: [],
      project: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.incubatorUuid = this.props.incubatorUuid;
    this.stations = this.props.stations;
    this.getIncuStationList();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.incubatorUuid !== nextProps.incubatorUuid) {
      this.incubatorUuid = nextProps.incubatorUuid;
      this.getIncuStationList();
    }
    if (this.props.stations && this.props.stations.length !== nextProps.stations.length) {
      this.stations = nextProps.stations;
      this.initSeatStatus();
    }
  }

  getCheckedUuids = data => {
    const uuids = [];
    const selected = [];
    let disableLen = 0; // 选择工位被禁用工位的数量
    let price = 0; // 选择工位的总价
    Object.keys(data).forEach(item => {
      if (data[item].isChecked) {
        uuids.push(data[item].uuid);
        selected.push(data[item]);
        price += data[item].unit;
        if (!data[item].isEnable) {
          disableLen++;
        }
      }
    });
    if (this.props.handleChange) {
      this.props.handleChange(uuids, price, disableLen);
    }
  };

  getIncuStationList = () => {
    this.setState({
      isLoading: true,
    });
    queryIncuStationList({
      incubatorUuid: this.incubatorUuid,
    }).then(res => {
      const data = {};
      const rows = [];
      const columns = [];
      const units = [];
      const unitClass = {};
      res.data.forEach(item => {
        if (rows.indexOf(item.x) < 0) {
          rows.push(item.x);
        }
        if (columns.indexOf(item.y) < 0) {
          columns.push(item.y);
        }
        if (units.indexOf(item.unit) < 0) {
          units.push(item.unit);
        }
        data[`${item.x}${item.y}`] = item;
      });
      this.sortRows(rows);
      units.sort((a, b) => a - b);
      units.forEach((item, index) => {
        unitClass[item] = `seat-cell-unit${index}`;
      });
      columns.sort((a, b) => a - b);
      this.initSeatStatus(data);
      this.setState({
        columns,
        rows,
        unitClass,
        isLoading: false,
      });
    });
  };

  sortRows = rows => {
    let temp = '';
    for (let i = 0; i < rows.length - 1; i++) {
      for (let j = i + 1; j < rows.length; j++) {
        if (rows[j].length < rows[i].length) {
          temp = rows[i];
          rows[i] = rows[j];
          rows[j] = temp;
        } else if (rows[j].length === rows[i].length && rows[j] < rows[i]) {
          temp = rows[i];
          rows[i] = rows[j];
          rows[j] = temp;
        }
      }
    }
  };

  setSeatStatus = key => {
    if (this.props.disabled) {
      return;
    }
    const { data } = this.state;
    data[key].isChecked = !data[key].isChecked;
    this.getCheckedUuids(data);
    this.setState({
      data,
      project: '',
    });
  };

  /**
   * 显示某个基础孵化合同对应的工位
   */
  initSeatStatus = data => {
    const stations = this.stations || [];
    stations.forEach(item => {
      const key = item.x + item.y;
      if (!data[key]) {
        return;
      }
      data[key].isChecked = !data[key].isChecked;
    });
    this.getCheckedUuids(data);
    this.setState({
      data,
    });
  };

  handleCheckColumn = key => {
    const { data } = this.state;
    const theColumn = Object.keys(data).filter(item => data[item].y === key);
    const includeFlag = theColumn.every(item => data[item].isChecked);
    if (includeFlag) {
      theColumn.forEach(item => {
        data[item].isChecked = false;
      });
    } else {
      theColumn.forEach(item => {
        data[item].isChecked = true;
      });
    }
    this.getCheckedUuids(data);
    this.setState({
      data,
    });
  };

  handleCheckRow = key => {
    const { data } = this.state;
    const theRow = Object.keys(data).filter(item => data[item].x === key);
    const includeFlag = theRow.every(item => data[item].isChecked);
    if (includeFlag) {
      theRow.forEach(item => {
        data[item].isChecked = false;
      });
    } else {
      theRow.forEach(item => {
        data[item].isChecked = true;
      });
    }
    this.getCheckedUuids(data);
    this.setState({
      data,
    });
  };

  handleCloumnClass = key => {
    const { data } = this.state;
    const theColumn = Object.keys(data).filter(item => data[item].y === key);
    const includeFlag = theColumn.every(item => data[item].isChecked);
    if (includeFlag) {
      return 'column-item seat-cell seat-cell-checked';
    }
    return 'column-item seat-cell';
  };

  handleRowClass = key => {
    const { data } = this.state;
    const theRow = Object.keys(data).filter(item => data[item].x === key);
    const includeFlag = theRow.every(item => data[item].isChecked);
    if (includeFlag) {
      return 'column-item seat-cell seat-cell-checked';
    }
    return 'column-item seat-cell';
  };

  setCurrentProject = key => {
    this.setState({
      project: key,
    });
  };

  isBelong = uuid => {
    const { stations } = this.props;
    return stations.some(item => {
      return item.uuid === uuid;
    });
  };

  render() {
    const { columns, rows, data, unitClass, project, isLoading } = this.state;
    return (
      <div
        className="seat-table"
        id="seat-table"
        ref={ref => {
          this.seatTable = ref;
        }}
      >
        <div className="identifying">
          <div className="title">价格：</div>
          {Object.keys(unitClass).map(item => (
            <div className="identifying-item" key={item}>
              <div className={`${unitClass[item]} seat-cell`} />
              <span>{item}</span>
            </div>
          ))}
        </div>
        <div className="identifying">
          <div className="title">状态：</div>
          <div className="identifying-item">
            <div className="seat-cell-enable seat-cell" />
            <span>可用</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-disable seat-cell" />
            <span>禁用</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-used seat-cell" />
            <span>已用</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-disabled-used seat-cell" />
            <span>已用（禁用）</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-audit seat-cell" />
            <span>审核中</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-checked seat-cell" />
            <span>选中</span>
          </div>
          <div className="identifying-item">
            <div className="seat-cell-light seat-cell" />
            <span>高亮</span>
          </div>
        </div>
        <Spin spinning={isLoading}>
          <Card>
            <div className="seat-column">
              <div style={{ width: '30px', height: '30px', marginRight: '10px' }} />
              {columns.map(item => (
                <div
                  className={this.handleCloumnClass(item)}
                  key={item}
                  onClick={() => this.handleCheckColumn(item)}
                >
                  {item}
                </div>
              ))}
            </div>
            <div>
              <div style={{ float: 'left' }} className="">
                {rows.map(item => (
                  <div
                    key={item}
                    className={this.handleRowClass(item)}
                    onClick={() => this.handleCheckRow(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div className="">
                {rows.map((item, index) => {
                  return (
                    <div key={item} style={{ display: 'flex' }}>
                      {columns.map(item2 => {
                        if (!data[`${item}${item2}`]) {
                          return null;
                        }
                        const { x, y } = data[`${item}${item2}`];
                        const key = `${x}${y}`;
                        return (
                          <Tooltip placement="topLeft" title={data[key].company} key={key}>
                            <div
                              onMouseEnter={() => this.setCurrentProject(data[key].companyUuid)}
                              onMouseLeave={() => this.setCurrentProject('')}
                              className={`
																		column-item seat-cell
																		${data[key].isEnable ? 'seat-cell-enable' : ''}
                                    ${
                                      data[key].isUsed === 1 && data[key].isEnable
                                        ? 'seat-cell-used'
                                        : ''
                                    }
                                    ${
                                      data[key].isUsed === 1 && !data[key].isEnable
                                        ? 'seat-cell-disabled-used'
                                        : ''
                                    }
                                    ${data[key].isUsed === 2 ? 'seat-cell-audit' : ''}
																		${unitClass[data[key].unit]}
																		${project && data[key].companyUuid === project ? 'seat-cell-light' : ''}
																		${data[key].isChecked ? 'seat-cell-checked' : ''}
																		`}
                              onClick={() => this.setSeatStatus(key)}
                            />
                          </Tooltip>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </Card>
        </Spin>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/seat/ComSeatTable.js